import React from 'react'
import { Box, Dialog, Divider, ListItemIcon, TextField, MenuItem } from '@mui/material';
import { GrUserAdmin } from "react-icons/gr";
import { RiAdminLine } from "react-icons/ri";
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Tooltip from '@mui/material/Tooltip';
import { useNavigate } from 'react-router-dom';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteIcon from '@mui/icons-material/Delete';
import PrintIcon from '@mui/icons-material/Print';
import DownloadIcon from '@mui/icons-material/Download';
import AttachEmailIcon from '@mui/icons-material/AttachEmail';
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch';
import { useSelector } from 'react-redux';
import LinkIcon from '@mui/icons-material/Link';
import LoadingShort from '../load/loadingShort';
import MessageSuccess from '../messages/messageSuccess';
import MessageError from '../messages/messageError';
import { Button, DialogActions, DialogContent, DialogContentText, DialogTitle, Slide } from '@mui/material';
import VerifyPermission from './verifyPermission';
import Download from '@mui/icons-material/Download';
import { IoReloadSharp } from 'react-icons/io5';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function HeaderGestorConfigs(props) {
    const navigate = useNavigate();
    const user = useSelector(state => state.account.user);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (
        <>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <Box sx={{ flexGrow: 1 }} >
                    <Typography variant="subtitle1" style={{ fontSize: 20 }}>
                        {props?.load ? <LoadingShort /> : ''} {props?.title}
                        {props?.messegeSuccess && <MessageSuccess message={props?.messegeSuccess} />}
                        {props?.messegeError && <MessageError message={props?.messegeError} />}
                    </Typography>
                    {props?.subtitle &&
                        <Typography variant="subtitle2" color="textSecondary" sx={{ marginRight: 2 }}>
                            {props?.subtitle}
                        </Typography>
                    }
                </Box>

                <React.Fragment>

                    {props?.menu &&
                        <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                            <Tooltip title="Mais opções">
                                <IconButton
                                    onClick={handleClick}
                                    size="small"
                                    // sx={{ ml: 1 }}
                                    aria-controls={open ? 'account-menu' : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={open ? 'true' : undefined}
                                >
                                    <MenuIcon />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    }
                    <Menu
                        anchorEl={anchorEl}
                        id="account-menu"
                        open={open}
                        onClose={handleClose}
                        onClick={handleClose}
                        PaperProps={{
                            elevation: 0,
                            sx: {
                                overflow: 'visible',
                                filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                                mt: 1.5,
                                '& .MuiAvatar-root': {
                                    width: 32,
                                    height: 32,
                                    ml: -0.5,
                                    mr: 1,
                                },
                                '&::before': {
                                    content: '""',
                                    display: 'block',
                                    position: 'absolute',
                                    top: 0,
                                    right: 14,
                                    width: 10,
                                    height: 10,
                                    bgcolor: 'background.paper',
                                    transform: 'translateY(-50%) rotate(45deg)',
                                    zIndex: 0,
                                },
                            },
                        }}
                        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                    >
                        {(props?.configArea === 'recibo' || props?.configArea === 'inspeccao') &&
                            <div>
                                <MenuItem size='small' onClick={() => props?.generatePDF('print')}> <ListItemIcon> <PrintIcon color='secondary' />  </ListItemIcon> Imprimir </MenuItem>
                                <MenuItem size='small' onClick={() => props?.generatePDF('save')}> <ListItemIcon> <DownloadIcon color='secondary' />  </ListItemIcon>  Baixar PDF </MenuItem>
                                <MenuItem size='small' onClick={() => props?.setOpenReenviarEmail(true)}> <ListItemIcon> <AttachEmailIcon color='secondary' />  </ListItemIcon>  Enviar por email </MenuItem>
                            </div>
                        }


                        {props?.configArea === 'fichaCadastramento' &&
                            <div>
                                {/* <MenuItem size='small' onClick={() => navigate(`/exportar-ficha-estabelecimento/${props?.estabelecimento._id}`)}>Exportar </MenuItem> */}
                                {/* <MenuItem size='small' onClick={() => props?.exportToPDF()}> Imprimir </MenuItem> */}
                                <MenuItem size='small'><a style={{ textDecoration: 'none' }} href={`/exportar-ficha-estabelecimento/${props?.estabelecimento?._id}`}> Exportar</a> </MenuItem>
                            </div>
                        }

                        {props?.configArea === 'autorizacaoExercio' &&
                            <div>
                                <MenuItem size='small' onClick={() => navigate(`/admin/autorizacao-de-exercicio/${props?.autorizacao.estabelecimento?._id}`)}> <ListItemIcon> <LinkIcon color='secondary' /></ListItemIcon> Ir </MenuItem>
                                <MenuItem size='small' onClick={() => props?.generatePDF(props?.autorizacao)}> <ListItemIcon> <PrintIcon color='secondary' />  </ListItemIcon> Imprimir </MenuItem>
                                <VerifyPermission permissions={user?.permissions} permission={'editAutorizacao'}>
                                    <MenuItem size='small' onClick={() => props?.setIsEdit(props?.autorizacao._id)}> <ListItemIcon> <ModeEditIcon color='secondary' />  </ListItemIcon> Editar Autorização </MenuItem>
                                    <MenuItem size='small' onClick={() => props?.reemissaoAutorizacao(props?.autorizacao._id)}> <ListItemIcon> <IoReloadSharp  color='secondary' />  </ListItemIcon> Reemitir Autorização </MenuItem>
                                </VerifyPermission>
                                {/* <MenuItem size='small' onClick={() => props?.setOpenReenviarEmail(true)}> <ListItemIcon> <AttachEmailIcon color='secondary' />  </ListItemIcon>  Enviar por email </MenuItem> */}
                            </div>
                        }


                        {props?.configArea === 'qrCode' &&
                            <div>
                                {/* <MenuItem size='small' onClick={() => navigate(`/exportar-qrcode-estabelecimento/${props?.estabelecimento._id}`)}>Exportar </MenuItem> */}
                                <MenuItem size='small' onClick={() => props?.exportQrCode()}>  <ListItemIcon> <PrintIcon color='secondary' />  </ListItemIcon>  Imprimir </MenuItem>
                            </div>
                        }


                        {props?.configArea === 'fichaEstabelecimento' &&
                            <div>
                                {user ?
                                    <>
                                        <MenuItem size='small' onClick={() => navigate(`/admin/gestor-licenciados/${props?.estabelecimento._id}`)}> <ListItemIcon> <LinkIcon color='secondary' /></ListItemIcon> Ir </MenuItem>
                                        <MenuItem size='small' onClick={() => props?.setEditDados(!props?.editDados)}> <ListItemIcon> <ModeEditIcon color='secondary' /></ListItemIcon> Editar dados </MenuItem>
                                        <MenuItem size='small' onClick={() => props?.setChangeDirectorTecnico(true)}> <ListItemIcon> <img src="/icones/Director_tecnico2.svg" width={25} alt="" /> </ListItemIcon>  Mudar de Director Técnico </MenuItem>
                                        <MenuItem size='small' onClick={() => props?.delete(true)}> <ListItemIcon> <DeleteIcon color='secondary' />  </ListItemIcon> Eliminar estabelecimento  </MenuItem>
                                        <MenuItem size='small' onClick={() => props?.setOpenEnviarNotificacao(true)}> <ListItemIcon>  </ListItemIcon> Enviar notificação </MenuItem>
                                        {props?.estabelecimento?.status === 'Reprovado' &&
                                            <MenuItem size='small' onClick={() => props?.setOpenReenviarLinkReprovacao(true)}> <ListItemIcon>  </ListItemIcon> Reenviar link de reprovação  </MenuItem>
                                        }
                                    </>
                                    :
                                    <MenuItem size='small' onClick={() => props?.setEditDados(!props?.editDados)}> <ListItemIcon> <ModeEditIcon color='secondary' /></ListItemIcon> Editar dados </MenuItem>
                                }
                            </div>
                        }


                        {props?.configArea === 'dadosempresa' &&
                            <div>
                                {user ?
                                    <>
                                        <MenuItem size='small' onClick={() => navigate(`/admin/get-empresa/${props?.empresa?._id}`)}> <ListItemIcon> <LinkIcon color='secondary' /></ListItemIcon> Ir </MenuItem>
                                        <MenuItem size='small' onClick={() => props?.setEditDados(!props?.editDados)}> <ListItemIcon> <ModeEditIcon color='secondary' />  </ListItemIcon>  Editar dados </MenuItem>
                                        <MenuItem size='small' onClick={() => props?.setChangeRepresentante(true)}> <ListItemIcon> <img src="/icones/representante2.svg" width={25} alt="" />  </ListItemIcon> Mudar de Representante </MenuItem>
                                        <MenuItem disabled size='small' onClick={() => props?.delete(true)}> <ListItemIcon> <DeleteIcon color='secondary' />  </ListItemIcon>  Eliminar Empresa </MenuItem>
                                    </>
                                    :
                                    <MenuItem size='small' onClick={() => props?.setEditDados(!props?.editDados)}> <ListItemIcon> <ModeEditIcon color='secondary' /></ListItemIcon> Editar dados </MenuItem>
                                }
                            </div>
                        }


                        {props?.configArea === 'noticia' &&
                            <div>
                                {props?.noticia.status === "Inactivo" &&
                                    <MenuItem size='small' onClick={() => props?.HandleEdit(props?.noticia)}> Publicar agora </MenuItem>
                                }
                                <MenuItem size='small' onClick={() => props?.HandleEdit(props?.noticia)}> <ListItemIcon> <ModeEditIcon color='secondary' />  </ListItemIcon>  Editar </MenuItem>
                            </div>
                        }


                        {props?.configArea === 'fichaAdmin' &&
                            <div>
                                {props?.editDados === false &&
                                    <MenuItem size='small' onClick={() => props?.setOpenEditFoto(true)}> Editar Imagem </MenuItem>
                                }
                                <VerifyPermission permissions={user?.permissions} permission={'acessarPerfilsUser'}>
                                    <MenuItem size='small' onClick={() => navigate(`/admin/perfil-admin/${props?.dadosPessoalAdmin?._id}`)}> <ListItemIcon> <LinkIcon color='secondary' /></ListItemIcon> Perfil </MenuItem>
                                </VerifyPermission>
                                <MenuItem size='small' onClick={() => props?.setEditDados('senha')}> <ListItemIcon> <ModeEditIcon color='secondary' />  </ListItemIcon>  Editar senha </MenuItem>
                                <MenuItem size='small' onClick={() => props?.setIsEdit(true)}> <ListItemIcon> <ModeEditIcon color='secondary' />  </ListItemIcon>  Editar dados pessoais </MenuItem>
                                <VerifyPermission permissions={user?.permissions} permission={'concederPermissions'}>
                                    <MenuItem size='small' onClick={() => props?.setEditDados('gerenciarPrivilegios')}> <ListItemIcon> <ModeEditIcon color='secondary' />  </ListItemIcon>  Editar privilégios </MenuItem>
                                </VerifyPermission>
                                <MenuItem size='small' onClick={() => props?.printQrCode(props?.dadosPessoalAdmin?.dadosPessoais?._id)}> <ListItemIcon> <PrintIcon color='secondary' />  </ListItemIcon>  Imprimir QRCode </MenuItem>
                                <MenuItem size='small' onClick={() => props?.changeToRepresentante()}> <ListItemIcon><GrUserAdmin color='#9C27B0' />  </ListItemIcon>Tornar Representante</MenuItem>
                                <MenuItem size='small' onClick={() => props?.setOpenRepresentante(true)}> <ListItemIcon><RiAdminLine color='#9C27B0' /> </ListItemIcon>Tornar Diretor Técnico</MenuItem>
                            </div>
                        }


                        {props?.configArea === 'fichaRepresentante' &&
                            <div>
                                {user ?
                                    <>
                                        <MenuItem size='small' onClick={() => navigate(`/admin/get-representante/${props?.representante?._id}`)}> <ListItemIcon> <LinkIcon color='secondary' /></ListItemIcon> Ir </MenuItem>
                                        <MenuItem size='small' onClick={() => props?.setEditDados(!props?.editDados)}> <ListItemIcon> <ModeEditIcon color='secondary' />  </ListItemIcon>  Editar dados pessoal </MenuItem>
                                        <MenuItem size='small' onClick={() => props?.delete(true)}> <ListItemIcon> <DeleteIcon color='secondary' />  </ListItemIcon>  Eliminar Representante </MenuItem>
                                        <MenuItem size='small' onClick={() => props?.representanteCreateDirectorTecnico(true)}> <ListItemIcon> '' </ListItemIcon>  Criar Director Técnico </MenuItem>
                                    </>
                                    :
                                    <MenuItem size='small' onClick={() => props?.setEditDados(!props?.editDados)}> <ListItemIcon> <ModeEditIcon color='secondary' /></ListItemIcon> Editar dados </MenuItem>
                                }
                            </div>
                        }


                        {props?.configArea === 'fichaDT' &&
                            <div>
                                {user ?
                                    <>
                                        <MenuItem size='small' onClick={() => navigate(`/admin/get-director-tecnico/${props?.directorTecnico?._id}`)}> <ListItemIcon> <LinkIcon color='secondary' /></ListItemIcon> Ir </MenuItem>
                                        <MenuItem size='small' onClick={() => props?.setEditDados('dadospessoaledit')}><ListItemIcon> <ModeEditIcon color='secondary' />  </ListItemIcon>  Editar dados pessoal </MenuItem>
                                        <MenuItem size='small' onClick={() => props?.setEditDados('dadosdirectortecnicoedit')}><ListItemIcon> <ModeEditIcon color='secondary' />  </ListItemIcon>  Editar outros dados </MenuItem>
                                        <MenuItem size='small' onClick={() => props?.delete(true)}><ListItemIcon> <DeleteIcon color='secondary' />  </ListItemIcon>  Eliminar Director Técnico </MenuItem>
                                        <MenuItem size='small' onClick={() => props?.directorTecnicoCreateRepresentante(true)}> <ListItemIcon> '' </ListItemIcon>  Criar Representante </MenuItem>
                                    </>
                                    :
                                    <MenuItem size='small' onClick={() => props?.setEditDados('all')}> <ListItemIcon> <ModeEditIcon color='secondary' /></ListItemIcon> Editar dados </MenuItem>
                                }
                            </div>
                        }


                        {props?.configArea === 'AutoVistoria' &&
                            <div>
                                <MenuItem size='small' onClick={() => navigate(`/admin/modo-inspeccao/${props?.inspeccao?._id}`)} ><ListItemIcon> <ContentPasteSearchIcon color='secondary' />  </ListItemIcon>  Activar modo inspecção </MenuItem>
                            </div>
                        }
                    </Menu>

                    {props.actions &&
                        <DialogActions >
                            <Tooltip title="Baixar">
                                <IconButton onClick={props.handleExportPDF}>
                                    <Download />
                                </IconButton>
                            </Tooltip>
                        </DialogActions>
                    }
                </React.Fragment>
            </div>

            <Divider style={{ marginBottom: 10 }} />


            {/* REMOVER ESSES DIALOGS, CONFIGURAR FORA DESTE COMPONENTE */}
            <Dialog
                open={props?.openRepresentante}
                TransitionComponent={Transition}
                keepMounted
                onClose={props?.handleCloseRepresentante}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>{"Tornar Diretor Técnico"}</DialogTitle>
                <DialogContent style={{ display: 'flex', flexDirection: 'column', gap: '7px', minWidth: '500px' }}>
                    <DialogContentText id="alert-dialog-slide-description">
                        Preencha os campos abaixo:
                    </DialogContentText>
                    <TextField size='small' id="ordem" name='ordem' label="Ordem" variant="outlined" onChange={props?.handleChange} fullWidth />
                    <TextField size='small' id="nCarteira" name='numeroCarteira' label="Nº Carteira" variant="outlined" onChange={props?.handleChange} fullWidth />
                    <TextField
                        type="text"
                        placeholder="Categoria"
                        label='Categoria'
                        name='categoriaId'
                        select
                        size="small"
                        variant="outlined"
                        fullWidth
                        onChange={props?.handleChange}
                    >
                        {props?.categorias?.map((categoria) => (
                            < MenuItem key={categoria?._id} value={categoria?._id}>
                                {categoria?.designacao}
                            </MenuItem>
                        ))}
                    </TextField>
                </DialogContent>
                <DialogActions>
                    <Button onClick={props?.handleCloseRepresentante}>Cancelar</Button>
                    <Button disabled={props?.dadosRepresentante?.ordem === '' || props?.dadosRepresentante?.numeroCarteira === ''}
                        onClick={() => {
                            props?.setOpenConfirm(true);
                            props?.handleCloseRepresentante()
                        }}
                    >
                        Confirmar
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={props?.openConfirm}
                TransitionComponent={Transition}
                keepMounted
                onClose={props?.handleCloseConfirm}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>{"Tornar Diretor Técnico"}</DialogTitle>
                <DialogContent style={{ display: 'flex', flexDirection: 'column', gap: '7px', minWidth: '500px' }}>
                    <DialogContentText id="alert-dialog-slide-description">
                        Deseja tornar este usuário em Representante?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={props?.handleCloseConfirm}>Cancelar</Button>
                    <Button onClick={() => props?.changeToDirectorTecnico()}>{props?.load ? <LoadingShort /> : 'Sim'}</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
